import SeoHelmet from '../../components/common/SeoHelmet'
import PageTitle from '../../components/common/PageTitle'
import { useNavigate } from 'react-router-dom'
import SubscriptionPlanList from '../../components/subscription/SubscriptionPlanList'

const PricingPage = () => {
  const navigate = useNavigate()

  return (
    <div className="main-container">
      <SeoHelmet
        title="Pricing Plans"
        description="Explore Sokooni marketplace pricing plans for retailers and wholesalers. Find the perfect plan for your business needs with competitive rates."
        keywords="pricing plans, subscription, retailer plans, wholesaler plans, marketplace pricing, Sokooni plans"
        url="/pricing"
      />
      <PageTitle>Pricing Plans</PageTitle>
      <p className="text-gray-600 mb-8">
        Choose the best plan that suits your business needs. Whether you are a retailer or a
        wholesaler, we have flexible options for you.
      </p>

      <SubscriptionPlanList
        onGetStarted={() => {
          navigate('/login')
        }}
      />
    </div>
  )
}

export default PricingPage
